// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"7cf3a33a","205":"c48e85d3","209":"2592615d","375":"9e53c337","457":"5116c78f","548":"7b518081","551":"d3647d9b","629":"4b41466e","851":"f5cadd2d","873":"0f9c348d","950":"273c2ad4"}[chunkId] + ".chunk.js";
};